module.exports = __webpack_public_path__ + "img/C5BBB6_F8F4F1_E2DAD6_ECE3DF-256px.e6c6c9f4.png";